'use client'

export default function LoanChatPrefilledBadge({ estimate = false, className = '' }: { estimate?: boolean; className?: string }) {
    const tone = estimate
        ? 'border-amber-700 bg-amber-100 text-amber-900'
        : 'border-rm-blue bg-rm-blue-pale text-rm-blue'
    return (
        <span
            data-test={estimate ? 'chat-estimate-badge' : 'chat-prefilled-badge'}
            className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-bold tracking-wide ${tone} ${className}`}
        >
            <i className={`fa-regular ${estimate ? 'fa-question-circle' : 'fa-comment-dots'} text-[9px]`} aria-hidden="true" />
            {estimate ? 'Estimation de l’assistant, à confirmer' : 'Pré-rempli par l’assistant, modifiable'}
        </span>
    )
}
